import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;
const links = [['About', '#about'], ['Services', '#services'], ['Bridal', '#bridal'], ['Our Work', '#work'], ['Contact', '#contact']];

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <a href="#home" className="brand" aria-label="Saffron and Sage home">
          <span className="brand-mark">S<span>&</span>S</span>
          <span className="brand-name">SAFFRON <i>&</i> SAGE<small>HAIR · BEAUTY · GROOMING</small></span>
        </a>
        <button className="mobile-toggle" onClick={() => setOpen(!open)} aria-label="Toggle navigation">
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
        <nav className={`main-nav${open ? ' nav-open' : ''}`}>
          {links.map(([label, href]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>)}
          <a className="button button-dark nav-book" href="#appointment" onClick={() => setOpen(false)}>Book Appointment <SafeIcon icon={FiArrowUpRight} /></a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
